import { Component, OnInit, Input } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { TimeService } from 'src/app/services/time/time.service';
import { environment } from 'src/environments/environment';
import { Lambda } from 'aws-sdk';
import { isRegularExpressionLiteral } from 'typescript';
import { stringify } from '@angular/compiler/src/util';

const UPDATE_MAX_LENGTH = 5;
const RECORD_MAX_LENGTH = 5;
const RETRIES = 3;

@Component({
  selector: 'app-voicemail-extension-upload',
  templateUrl: './voicemail-extension-upload.component.html',
  styleUrls: ['./voicemail-extension-upload.component.css']
})
export class VoicemailExtensionUploadComponent implements OnInit {
  //batch upload
  batchData: Array<any> = [];
  filteredData: Array<any> = [];
  historicBatches: Array<any> = [];

  //file
  selectedFile: File = null;
  fileName: string = "";
  batchDescription: string = "";
  csvData: Array<string> = [];

  //header
  inputItemsPerPage: number = 10;
  itemsPerPage: number = 10;
  showAll: boolean = true;
  searchString: string = "";
  successCount: number = 0;
  errorCount: number = 0;

  //page
  lambdaError:boolean = false;
  lambdaMessage:string = '';
  username:string = '';
  batchSelect: any = ""
  batchIsSelected: boolean = false;
  disableProcessBatch: boolean = true;
  disableLoadFile: boolean = true;
  
  agentList: Array<any> = [];

  agentBluePrint = {
    agentId:"",
    deliveryEmail: true,
    deliveryOptions: {
      email: true,
      sms: {
        enabled: false,
        phoneNumber: "null"
      }
    },
    encryptVoicemail: false,
    extension: null,
    transcribeVoicemail: true,
    userId:"",
    username:""
  }

  constructor(private telecomService: TelecomService, private auth: AuthService, private timeService: TimeService) { }

  ngOnInit() {
    let identity = this.auth.userPool.getCurrentUser().username;
    if(identity.split("_").length === 2){
      this.username = identity.split('_')[1];
    }else{
      this.username = identity;
    }
    console.log(this.username);
    this.getBatchIds();
    this.getUserBatch("");
  }

  getUserBatch(next: string){
    let payload = {
      queryStringParameters: {
        size: 1000
      }
    };
    if(next !== ""){
      payload.queryStringParameters['next'] = next;
    }
    const params = {
      FunctionName: environment.AgentsGetLambdaName,
      Payload: JSON.stringify(payload)
    }
    this.telecomService.callLambda(params, "Failed to retrieve voicemail agents from connect.").then((response:any)=>{
      if(response.statusCode != 200){
        this.lambdaError = true;
        this.lambdaMessage = "Failed to retrieve Voicemail Users from Connect";
      }else{
        const parsed = JSON.parse(response.body);
        let temp = JSON.parse(JSON.stringify(this.agentList));                    //make a copy
        this.agentList = JSON.parse(JSON.stringify(temp.concat(parsed.data)));    //original = copy + new
        this.applyFilter();
        if(parsed.hasOwnProperty("next")){
          this.getUserBatch(parsed.next);
        }
      }
    });
  }

  uploadFile($event) {
    this.disableLoadFile = false;
    let csv: string = ""
    this.selectedFile = $event.target.files[0];
    this.fileName = this.selectedFile.name;
    console.log('name: ', this.selectedFile.name);
    console.log('size: ', this.selectedFile.size);
    console.log('type: ', this.selectedFile.type);
    let reader: FileReader = new FileReader();
    reader.readAsText(this.selectedFile);
    reader.onload = (e) => {
      console.log('e: ', e);
      csv = reader.result as string;
      let rows = csv.split('\n');
      for(let x=0; x < rows.length; x++){
        if(rows[x].split(',').join('').trim() == ''){
          rows.splice(x, 1); 
          x--;
        }
      }
      if(rows[rows.length -1] === ""){
        rows.pop();
      }
      console.log('rows: ', rows);
      this.csvData = rows;
      this.batchDescription = "";
    }
  }

  /**processes csv and sends it to be stored as a batch in batch table */
  submitCsvData(){
    this.lambdaError = false;
    this.lambdaMessage = '';
    this.batchData = [];

    let params = {
      FunctionName: environment.VoicemailExtensionRecordLambdaName,
      Payload: JSON.stringify({
        operation: "put",
        csvData: this.csvData,
        batchName: this.buildBatchName()
      })
    };
    this.telecomService.callLambda(params, "An error occurred while processing the user data").then(
      (response: any) => {
        if(response.statusCode == 200){
          this.batchSelect = response.body;
          this.getBatch(this.batchSelect); 
          this.getBatchIds();
        }else{
          this.lambdaError = true;
          this.lambdaMessage = "Failed to upload csv data"
        }
      },
      err => {
        this.lambdaError = true;
        this.lambdaMessage = "Failed to upload csv data"
      }
    );
  }

  /**returns a selected batch to be displayed in the UI and processed*/
  getBatch(batchId: string){
    this.lambdaError = false;
    this.lambdaMessage = '';
    this.batchData = [];

    let params = {
      FunctionName: environment.VoicemailExtensionRecordLambdaName,
      Payload: JSON.stringify({
        operation: "get",
        "batchId": batchId
      })
    };
    this.telecomService.callLambda(params, "Failed to retrieve the specified batch").then(
      (response:any) => {
        if(response.statusCode == 200){
          this.batchData = response.body;
          this.applyFilter();
          this.statusCount();
          this.disableProcessBatch = false;
        }else{
          this.lambdaError = true;
          this.lambdaMessage = "Failed to retrieve the specified batch";
        }
      }
      ,err => {
        this.lambdaError = true;
        this.lambdaMessage = "Failed to retrieve the specified batch";
      }
    );
  }

  /**returns batchIds and batchNames so user can select batch to be retrieved and displayed */
  getBatchIds(){
    this.lambdaError = false;
    this.lambdaMessage = '';
    this.historicBatches = [];

    let params = {
      FunctionName: environment.GetBatchListLambdaName,
      Payload: JSON.stringify({})
    };
    this.telecomService.callLambda(params, "An error occurred while processing the user data").then(
      (response:any) => {
        if(response.statusCode == 200){
          this.historicBatches = response.body
          this.statusCount();
        }else{
          this.lambdaError = true;
          this.lambdaMessage = "Failed to retrieve batch history"
        }
      },
      err => {
        this.lambdaError = true;
        this.lambdaMessage = "Failed to retrieve batch history"
      }
    ); 
  }

  /**selected batch will be processed and rows will be added to agent table */
  async processData(){
    this.disableProcessBatch = true;
    this.lambdaError = false;
    this.lambdaMessage = '';
    let recordTableUpdate = [];
    let data = [];

    console.info("Starting data processing...")
    // 1: filter out previously successful data
    for(let x=0; x<this.batchData.length; x++){
      if(this.batchData[x].status != 'processed'){
        data.push(this.batchData[x])
      }
    }
    // 2: build update list. holds the data for both updateAgentById api call and recordTableUpdate
    data = data.map(x => {
      let item = {
        recordData: x,
        updateData: null,
        responsePayload: null,
        update: true
      }
      let found = false;
      for(let y=0; y<this.agentList.length; y++){
        if(this.agentList[y].Username === item['recordData'].username){
          item['updateData'] = this.buildUpdateObject(this.agentList[y], item['recordData'].extension);
          found = true;
          break;
        }
      }
      if(!found){
        console.info("No match found for " + item['recordData'].username);
        item['update'] = false;
        item['recordData']['status']="error"
        item['recordData']['message']="No match for username: " + item['recordData']['username']
      }
      return item;
    });
    // 3: remove already failed items, set aside for record table update
    for(let x=0; x<data.length; x++){
      if(!data[x]['update']){
        recordTableUpdate.push(data[x]['recordData']);
        data.splice(x, 1);
        x--;
      }
    }
    // 4: split agent items into groups of maximum length UPDATE_MAX and process
    let chunks = [];
    while(data.length > 0){
      chunks.push(data.splice(0, UPDATE_MAX_LENGTH));
    }
    console.info("Starting extension update...")
    // 5: invoke lambda, store results in record table
    let retries = 0
    while(chunks.length > 0){
      let nextChunk = true;
      let result = await this.invokeChunk(chunks[0]);
      for(let x=0; x<chunks[0].length; x++){
        let payload = JSON.parse(result[x]["Payload"] as string);
        console.log("payload : ", payload)
        if(payload.status == 200){
          chunks[0][x]['recordData']['status'] = "success"
          chunks[0][x]['recordData']['message'] = "ok"
          recordTableUpdate.push(JSON.parse(JSON.stringify(chunks[0][x]['recordData'])));
          chunks[0].splice(x, 1);
          result.splice(x, 1);
          x--;
        }else{
          nextChunk = false;
          chunks[0][x]['recordData']['status'] = "error"
          chunks[0][x]['recordData']['message'] = "extension update failed"
        }
        if(recordTableUpdate.length >= RECORD_MAX_LENGTH){
          this.updateRecordTable(recordTableUpdate);
          recordTableUpdate = [];
        }
      }
      if(nextChunk){
        retries = 0;
        chunks.splice(0, 1);
      }else{
        retries ++;
        if(retries > RETRIES){
          for(let x=0; x<chunks[0].length; x++){
            recordTableUpdate.push(JSON.parse(JSON.stringify(chunks[0][x]['recordData'])));
          }
          if(recordTableUpdate.length >= RECORD_MAX_LENGTH){
            this.updateRecordTable(recordTableUpdate);
            recordTableUpdate = [];
          }
          retries = 0;
          chunks.splice(0, 1);
        }else{
          let waitTime = retries * 1000;
          console.log("waiting for " + String(waitTime) + " milliseconds.");
          await new Promise(resolve => setTimeout(resolve, waitTime));
          console.log("done");
        }
      }
      
    }
    if(recordTableUpdate.length > 0){
      this.updateRecordTable(recordTableUpdate);
      recordTableUpdate = [];
    }
    this.disableProcessBatch = false;
  }

  buildUpdateObject(agentObject: any, extension){
    if(!agentObject.hasOwnProperty("deliverOptions")){
      let temp = JSON.parse(JSON.stringify(this.agentBluePrint));
      temp.userId = agentObject.userId;
      temp.agentId = agentObject.agentId;
      temp.username = agentObject.username;
      agentObject = temp;
    }
    let phone = agentObject.deliveryOptions.sms.phoneNumber;
    if(phone == 'null'){
      phone = null;
    }
    let body = {
      "extension": extension,
      "deliverSMSPhoneNumber": phone,
      "deliverSMS": agentObject.deliveryOptions.sms.enabled,
      "deliverEmail": agentObject.deliveryOptions.email,
      "encryptVoicemail": agentObject.encryptVoicemail,
      "transcribeVoicemail": agentObject.transcribeVoicemail
    }
    if(body.extension.trim() === "" || body.extension.toLowerCase().trim() === "none"){
      body.extension = null;
    }
    return {
      "body": body,
      "agentId": agentObject.agentId
    };
  }

  invokeChunk(chunk: Array<any>){
    return Promise.all(
      chunk.map(item => {
        let params = {
          FunctionName: environment.UpdateConnectUserLambdaName,
          Payload: JSON.stringify({
            "username": item['recordData']['username'],
            "operation": "put",
            "extension": item['recordData']['extension']
          })
        };
        let lambda = new Lambda();
        return lambda.invoke(params).promise();
      })
    )
  }

  /** update table with results */
  updateRecordTable(recordTableUpdate: Array<any>){
    console.info("updating record table...");
    console.log("update list: ", recordTableUpdate)
    let params = {
      FunctionName: environment.VoicemailExtensionRecordLambdaName,
      Payload: JSON.stringify({
        operation: "put",
        data: recordTableUpdate,
        batchName: this.buildBatchName()
      })
    };
    this.telecomService.callLambda(params, 'An error occurred. Failed to record the extension update processes results.').then(
      (response: any) => {
        if(response.statusCode != 200){
          this.lambdaError = true;
          this.lambdaMessage = 'An error occurred. Failed to record the extension update processes results.'
        }else{
          this.getBatch(this.batchSelect);
        }
      },
      err => {
        this.lambdaError = true;
        this.lambdaMessage = 'An error occurred. Failed to record the extension update processes results.'
      }
    );
  }

  applyFilter(){
    let temp = []
    let search = this.searchString.toLowerCase();
    this.batchData.map(x => {
      if(x.username.toLowerCase().includes(search) || x.extension.toLowerCase().includes(search)){
        if(this.showAll){
          temp.push(x);
        }else if(x.status != 'success'){
          temp.push(x);
        }
      }
    });
    temp.sort((a, b) => {
      if(a.username < b.username){
        return -1
      }else if (a.username > b.username){
        return 1
      }
      return 0;
    })
    this.filteredData = JSON.parse(JSON.stringify(temp));
  }

  statusCount(){
    this.successCount = 0;
    this.errorCount = 0;
    this.batchData.map(x => {
      if(x.status == 'success'){
        this.successCount ++;
      }else{
        this.errorCount ++;
      }
    });
  }

  buildBatchName(){
    let timeStamp = this.timeService.newTimeStamp();
    let batchName = this.username + timeStamp;
    console.log("batch name: ", batchName);
    return batchName;
  }

  cancelSelectedBatch(){
    this.batchData = [];
    this.filteredData = [];
    this.searchString = "";
    this.disableProcessBatch = true;
  }

  enforceMaxNumber(){
    if(this.itemsPerPage == null){
      this.inputItemsPerPage = 1;
    }else{
      if(this.itemsPerPage > 200){
        this.itemsPerPage = 200;
      }else if (this.itemsPerPage < 1){
        this.itemsPerPage = 1
      }
      this.inputItemsPerPage = this.itemsPerPage;
    }
  }

  cleanField(){
    if(this.itemsPerPage == null){
      this.itemsPerPage = 1;
    }
    this.enforceMaxNumber();
  }

}
